import { createApp } from 'vue'

import ProjectList from './vue/ProjectList.vue'

createApp(ProjectList)
    .mount('#app')
